import * as React from 'react';

import { pageDate } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';
import { downloadAction } from 'lib/seo/seo';

import PageSectionHeroSplash from 'components/page/sections/page-section-hero-splash';

export const DateHeroBlockContainer: React.FC = () => {
  const props = {
    title: pageDate.lxPageDateHeroBlockTitle,
    backgroundImageSrcPortrait: `${CdnImagePath}/landing/assets/photos/date-hero-portrait.jpg`,
    backgroundObjectPositionPortrait: '10% 40%',
    backgroundImageSrcLandscape: `${CdnImagePath}/landing/assets/photos/date-hero-landscape.jpg`,
    backgroundObjectPositionLandscape: '14% 14%',
    subTitle: pageDate.lxPageDateHeroBlockText,
    actionText: pageDate.lxPageDateHeroBlockCta,
    actionUrl: downloadAction,
  };

  return (
    <PageSectionHeroSplash
      title={props.title}
      subTitle={props.subTitle}
      action={{
        text: props.actionText,
        href: props.actionUrl,
      }}
      image={{
        srcPortrait: props.backgroundImageSrcPortrait,
        objectPositionPortrait: props.backgroundObjectPositionPortrait,
        srcLandscape: props.backgroundImageSrcLandscape,
        objectPositionLandscape: props.backgroundObjectPositionLandscape,
        hasFrontFilter: true,
        hasLoadPriority: true,
      }}
    />
  );
};
